@if (commentaire) {
  <div class="flex-horizontal flex-center" [ouiTooltip]="commentaire" [ouiTooltipPosition]="'left'">
    <oui-icon>comment</oui-icon>
  </div>
}
